export default __webpack_public_path__ + "static/media/dot_list_icon.21f89695.svg";